import "./Register.scss";
import { NavLink, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { registerNewUserAPI } from "../api/ClientApi";
const Register = (props) => {
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [coPassword, setCoPassword] = useState("");
  const defaultObjectCheck = {
    isValidUserName: true,
    isValidEmail: true,
    isValidPassword: true,
    isValidConfirmPassword: true,
  };
  const [objectCheckInput, setObjectCheckInput] = useState(defaultObjectCheck);
  const history = useHistory();

  // useEffect(() => {}, []);
  const handleRegister = () => {
    let invalid = invalidInputs();
    // console.log("User Data Register,", JSON.stringify(userData));
    if (invalid) {
      registerNewUserAPI({
        username: userName,
        email: email,
        password: password,
      }).then((response) => {
        let { errorCode, message } = response;
        if (errorCode === 0) {
          toast.success(message);
          history.push("/login");
        } else {
          toast.error(message);
        }
      });
    }
  };

  const invalidInputs = () => {
    setObjectCheckInput(defaultObjectCheck);
    if (!userName) {
      toast.error("Username is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidUserName: false });
      return false;
    }
    if (!email) {
      toast.error("Email is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    var re = /\S+@\S+\.\S+/;
    if (!re.test(email)) {
      toast.error("Email is invalid!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    if (!password) {
      toast.error("Password is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidPassword: false });
      return false;
    }
    if (!coPassword) {
      toast.error("Confirm password is not empty!");
      setObjectCheckInput({
        ...defaultObjectCheck,
        isValidConfirmPassword: false,
      });

      return false;
    }
    if (password !== coPassword) {
      toast.error("Password and confirm password is not the same!");
      setObjectCheckInput({
        ...defaultObjectCheck,
        isValidConfirmPassword: false,
      });
      return false;
    }
    // Without it, your current regex only matches that you have 6 to 16 valid characters,
    // it doesn't validate that it has at least a number, and at least a special character. That's what the lookahead above is for.
    // (?=.*[0-9]) - Assert a string has at least one number;
    // (?=.*[!@#$%^&*]) - Assert a string has at least one special character.
    var passRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
    if (!passRegex.test(password)) {
      toast.error(
        "Passwod has at least one number and least one special character!"
      );
      setObjectCheckInput({ ...defaultObjectCheck, isValidPassword: false });
      return false;
    }
    return true;
  };

  return (
    <div class="Register-container">
      <div class="container">
        <div class="row">
          <div class="content-right mt-3 col-12 col-sm-5 d-flex flex-column gap-3 py-3 shadow-lg p-3 mb-5 bg-body rounded">
            <div class="brand">Facebook</div>
            <input
              class={
                objectCheckInput.isValidUserName
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="Username"
              value={userName}
              onChange={(event) => setUserName(event.target.value)}
            />
            <input
              class={
                objectCheckInput.isValidEmail
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="Email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <input
              class={
                objectCheckInput.isValidPassword
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="password"
              placeholder="Password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />

            <input
              class={
                objectCheckInput.isValidConfirmPassword
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="password"
              placeholder="Confirm Password"
              value={coPassword}
              onChange={(event) => setCoPassword(event.target.value)}
            />
            <button class="btn btn-primary" onClick={() => handleRegister()}>
              Register
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
